'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var coreRenderer = require('@tempi/core-renderer');
var React = require('react');
var type = require('./type.js');

const useHeaderPosition = (positionType) => {
  const headerRef = React.useRef(null);
  const [headerHeight, setHeaderHeight] = React.useState(110);
  const [direction, setDirection] = React.useState("");
  let oldScrollY = 0;
  const updateOldScrollY = coreRenderer.debounce((newValue) => oldScrollY = newValue, 100);
  const handleSticky = (stickyPosition) => {
    var _a, _b;
    if (window.pageYOffset >= stickyPosition) {
      (_a = headerRef == null ? void 0 : headerRef.current) == null ? void 0 : _a.classList.add("sticky");
    } else {
      (_b = headerRef == null ? void 0 : headerRef.current) == null ? void 0 : _b.classList.remove("sticky");
    }
  };
  const controlDirection = (stickyPosition) => {
    var _a, _b;
    if (window.pageYOffset >= stickyPosition) {
      (_a = headerRef == null ? void 0 : headerRef.current) == null ? void 0 : _a.classList.add("sticky");
      if ((window == null ? void 0 : window.scrollY) > oldScrollY) {
        setDirection("scrolldown");
      } else {
        setDirection("scrollup");
      }
      updateOldScrollY(window == null ? void 0 : window.scrollY);
    } else {
      (_b = headerRef == null ? void 0 : headerRef.current) == null ? void 0 : _b.classList.remove("sticky");
    }
  };
  React.useEffect(() => {
    var _a, _b;
    setHeaderHeight((_b = (_a = headerRef == null ? void 0 : headerRef.current) == null ? void 0 : _a.getClientRects()[0]) == null ? void 0 : _b.height);
  }, []);
  React.useEffect(() => {
    var _a;
    const headerPosition = (_a = headerRef == null ? void 0 : headerRef.current) == null ? void 0 : _a.offsetTop;
    const dynamicEvent = () => controlDirection(headerPosition);
    const stickyEvent = () => handleSticky(headerPosition);
    switch (positionType) {
      case type.PositionHeader.DYNAMIC:
        window == null ? void 0 : window.addEventListener("scroll", dynamicEvent);
        break;
      case type.PositionHeader.STICKY:
        window == null ? void 0 : window.addEventListener("scroll", stickyEvent);
        break;
    }
    return () => {
      window == null ? void 0 : window.removeEventListener("scroll", dynamicEvent);
      window == null ? void 0 : window.removeEventListener("scroll", stickyEvent);
    };
  }, [positionType]);
  return {
    headerRef,
    headerHeight,
    direction
  };
};

exports.useHeaderPosition = useHeaderPosition;
